import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=3107ba8d&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=3107ba8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107ba8d",
  null
  
)

export default component.exports